export default theme => ({
  shrink: {
    color: theme.palette.text.primary
  }
});
